module.exports = __webpack_public_path__ + "img/success.eed68651.svg";